export interface ActivityBreakdown {
  notInUse: number;
  other: number;
  sit: number;
  stand: number;
  totalTime: number;
  walk: number;
}

export interface IActivityTrackerInterval {
  from: string;
  to: string;
  type: number;
  idx: number;
  unit: string;
  value: ActivityBreakdown;
}

export interface IProcessedActivityTrackerInterval extends IActivityTrackerInterval {
  date: string; // alias for from, used by charts
  walk: number;
  sit: number;
  stand: number;
  other: number;
  notInUse: number;
  totalUsage: number;
  walkPercentage: number;
  sitPercentage: number;
  standPercentage: number;
  otherPercentage: number;
}

export function processActivityTrackerData(data: IActivityTrackerInterval[]): IProcessedActivityTrackerInterval[] {
  return data.map((item) => {
    const v = item.value || { notInUse: 0, other: 0, sit: 0, stand: 0, totalTime: 0, walk: 0 };
    const walk = Number(v.walk) || 0;
    const sit = Number(v.sit) || 0;
    const stand = Number(v.stand) || 0;
    const other = Number(v.other) || 0;
    const notInUse = Number(v.notInUse) || 0;
    const totalUsage = Number(v.totalTime) || 0;

    const activityTotal = walk + sit + stand + other;
    const walkPercentage = activityTotal > 0 ? (walk / activityTotal) * 100 : 0;
    const sitPercentage = activityTotal > 0 ? (sit / activityTotal) * 100 : 0;
    const standPercentage = activityTotal > 0 ? (stand / activityTotal) * 100 : 0;
    const otherPercentage = activityTotal > 0 ? (other / activityTotal) * 100 : 0;

    return {
      ...item,
      date: item.from,
      walk,
      sit,
      stand,
      other,
      notInUse,
      totalUsage,
      walkPercentage,
      sitPercentage,
      standPercentage,
      otherPercentage,
    };
  });
}
